import { Action, createAction, handleActions } from "redux-actions";
import { DetalleCotizacionView, Services } from "../types";

interface GetDetalleCotizacionCompletedPayload {
  detalleCotizacion: DetalleCotizacionView | null;
}

interface DetalleCotizacionState {
  esquemas: unknown[];
  hasChanged: boolean;
  esquemaSelected: unknown;
  failed: boolean;
  detalleCotizacion: DetalleCotizacionView | null;
}

const getDetalleCotizacionInited = createAction(
  "OBTENER_DETALLE_COTIZACION_INITED"
);
const getDetalleCotizacionCompleted = createAction(
  "OBTENER_DETALLE_COTIZACION_COMPLETED",
  (
    response: DetalleCotizacionView | null | undefined
  ): GetDetalleCotizacionCompletedPayload => ({
    detalleCotizacion: response ?? null,
  })
);
const getDetalleCotizacionFailed = createAction(
  "OBTENER_DETALLE_COTIZACION_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getDetalleCotizacion = (id: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getDetalleCotizacionInited());

      const response = await services.api
        .cotizaciones()
        .getDetalleCotizacion(id);

      dispatch(getDetalleCotizacionCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getDetalleCotizacionFailed(error));
    }
  };
};

const detalleCotizacionInitialState: DetalleCotizacionState = {
  esquemas: [],
  hasChanged: false,
  esquemaSelected: null,
  failed: false,
  detalleCotizacion: null,
};

const detalleCotizacionReducer = handleActions<DetalleCotizacionState, any>(
  {
    [getDetalleCotizacionInited.toString()]: (): DetalleCotizacionState => {
      return {
        ...detalleCotizacionInitialState,
      };
    },
    [getDetalleCotizacionCompleted.toString()]: (
      state: DetalleCotizacionState,
      action: Action<GetDetalleCotizacionCompletedPayload>
    ): DetalleCotizacionState => {
      return {
        ...state,
        detalleCotizacion: action.payload.detalleCotizacion,
        failed: false,
      };
    },
    [getDetalleCotizacionFailed.toString()]: (
      state: DetalleCotizacionState
    ): DetalleCotizacionState => {
      return {
        ...state,
        failed: true,
      };
    },
  },
  detalleCotizacionInitialState
);

export { detalleCotizacionReducer };
export { getDetalleCotizacion };
